import React, { FC } from 'react';

import { StandardRuleCompliance } from '@ariksa/compliance-policies/api';
import { Box, Stack, UseDisclosureProps } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import {
  ChakraMarkdown,
  DetailsIdentifier,
  StackedHeader,
} from 'components/DataDisplay';
import { Drawer } from 'components/Overlay';
import { PoliciesUnderSubControl } from 'containers/PolicyHub/Blueprints/Components/Blueprint/BlueprintPolicies/ComplianceBlueprint/PoliciesUnderSubControl';
import { selectBlueprints } from 'containers/PolicyHub/Blueprints/selectors';

interface Props {
  isOpen: boolean;
  onClose();
  subControl: StandardRuleCompliance;
  addPolicy?: UseDisclosureProps;
  selectedPolicies?: string[];
  setSelectedPolicies?(value: string[]);
  action?: 'Create' | 'Show' | 'Update';
}

export const PoliciesUnderSubControlDrawer: FC<Props> = props => {
  const {
    isOpen,
    onClose,
    subControl,
    selectedPolicies,
    setSelectedPolicies,
    action,
  } = props;
  const { blueprint } = useSelector(selectBlueprints);

  return (
    <Box>
      <Drawer
        styles={{
          content: { px: 0, maxW: '90rem', h: 'full' },
        }}
        isOpen={isOpen}
        onClose={onClose}
        closeButton
        header={
          <StackedHeader
            upper={blueprint.data.name}
            lower={subControl.control + ' / ' + subControl.sub_control}
            type={subControl.compliance}
            iconFilled={false}
          />
        }
        body={
          <Stack h="full" spacing={5}>
            <DetailsIdentifier
              label="Sub-Control Description"
              isInline={false}
              value={
                <ChakraMarkdown
                  content={subControl.sub_control_description || 'None'}
                />
              }
            />
            <PoliciesUnderSubControl
              subControl={subControl}
              selectedPolicies={selectedPolicies}
              setSelectedPolicies={setSelectedPolicies}
              action={action}
            />
          </Stack>
        }
      />
    </Box>
  );
};
